import { useEffect, useMemo } from 'react'
import { AssetsModule } from '@core/modules/digital-footprint/assets'
import { AppModule } from '@core/modules/app/app.module'
import { DialogService } from '@core/services/dialog'
import { unifiedDevicesFilterModule } from '../devices.filters'

export const useDevicesPage = () => {
    const { loading, data: allAssets } = AssetsModule.useStore()
    const { scanInProgress } = AppModule.useStore()
    const { filter, search } = unifiedDevicesFilterModule.useStore()

    const deviceAssets = useMemo(
        () => allAssets.filter((a) => a.asset_type === 'device'),
        [allAssets]
    )

    const integrationAssets = useMemo(
        () => allAssets.filter((a) => a.asset_type === 'integration'),
        [allAssets]
    )

    const filteredDevices = useMemo(
        () => unifiedDevicesFilterModule.processData(deviceAssets, false),
        [deviceAssets, filter, search]
    )

    useEffect(() => {
        return () => {
            DialogService.hideDialog('asset-details-dialog').catch(console.error)
        }
    }, [])

    return {
        loading,
        filteredDevices,
        integrationAssets,
        scanInProgress,
        emptyDevicesMessage: 'No devices found',
    }
}
